module.exports = __webpack_public_path__ + "img/cm.c972441e.svg";